import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "to",
    "period",
    "pricelistSelect",
    "periodSelect",
    "packagePricelistItemSelect",
    "packagePricelistItemSelectField",
    "seatsField"
  ]

  static values = {
    currentPricelistItemId: Number
  }

  connect() {
    this.toFields = null
    console.log("hi from subscription controller")
    this.waitForElem(this.toTarget.parentNode, "[data-calendar-target=\"calendar\"]").then((elem) => {
      this.toFields = [this.toTarget, elem]
      this.trigger()
    })
    this.pricelistChanged()
  }

  trigger() {
    if (this.toFields === null) return

    const period = this.periodTarget.value

    this.toFields.forEach(field => {
      if (field.dataset.manualEnable === "true") return
      if (period === "custom") {
        field.disabled = false
        field.required = true
        field.classList.remove("bg-gray-100")
        field.classList.add("bg-white")
      } else {
        field.disabled = true
        field.required = false
        field.value = ""
        field.classList.add("bg-gray-100")
        field.classList.remove("bg-white")
      }
    })
  }

  toggleToField(event) {
    if (this.toFields === null) return
    const btn = event.target
    const isDisabled = this.toFields.every(field => field.disabled)

    if (isDisabled) {
      this.toFields.forEach(field => {
        field.disabled = false
        field.dataset.manualEnable = "true"
        field.classList.remove("bg-gray-100")
        field.classList.add("bg-white")
      })
      btn.textContent = "Zablokuj"
    } else {
      this.toFields.forEach(field => {
        field.disabled = true
        field.value = ""
        delete field.dataset.manualEnable
        field.classList.add("bg-gray-100")
        field.classList.remove("bg-white")
      })
      btn.textContent = "Edytuj"
    }
  }

  pricelistChanged() {
    const selectedOption = this.pricelistSelectTarget.selectedOptions[0]
    const type = selectedOption?.dataset.type
    const addonType = selectedOption?.dataset.addonType

    if (type === "Billing::Addon" && addonType === "package") {
      this.showPackagePricelistItemSelect()
      this.updatePackagePricelistItems()
    } else {
      this.hidePackagePricelistItemSelect()
    }

    this.toggleSeatsField(selectedOption?.dataset.perUser === "true")
  }

  // Liczba miejsc ma sens tylko dla planów per-user - na addonach miejsca liczy quantity
  toggleSeatsField(perUser) {
    if (!this.hasSeatsFieldTarget) return

    this.seatsFieldTarget.style.display = perUser ? "" : "none"
  }

  periodChanged() {
    // Existing trigger logic for toFields
    if (typeof this.trigger === "function") this.trigger()
    // New logic for package select
    if (this.packagePricelistItemSelectTarget && this.packagePricelistItemSelectTarget.style.display !== "none") {
      this.updatePackagePricelistItems()
    }
  }

  showPackagePricelistItemSelect() {
    this.packagePricelistItemSelectTarget.style.display = ""
  }

  hidePackagePricelistItemSelect() {
    this.packagePricelistItemSelectTarget.style.display = "none"
    if (this.packagePricelistItemSelectFieldTarget) {
      this.packagePricelistItemSelectFieldTarget.innerHTML = ""
    }
  }

  updatePackagePricelistItems() {
    const pricelistId = this.pricelistSelectTarget.value
    const period = this.hasPeriodTarget ? this.periodTarget.value : null
    const itemsByPeriod = window.PRICELIST_ITEMS?.[pricelistId] || {}
    const items = period ? (itemsByPeriod[period] || []) : []

    if (!this.packagePricelistItemSelectFieldTarget) return
    this.packagePricelistItemSelectFieldTarget.innerHTML = ""
    const currentItemId = this.hasCurrentPricelistItemIdValue ? Number(this.currentPricelistItemIdValue) : null
    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.name
      // Pre-select the current pricelist_item_id if it matches
      if (currentItemId !== null && Number(item.id) === currentItemId) {
        option.selected = true
      }
      this.packagePricelistItemSelectFieldTarget.appendChild(option)
    })
  }

  waitForElem(elem, selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(elem.querySelector(selector))
      }

      const observer = new MutationObserver(_mutations => {
        if (document.querySelector(selector)) {
          observer.disconnect()
          resolve(elem.querySelector(selector))
        }
      })

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    })
  }
}
